export const listTheme = {
  'list-color': '--medkit-list-base-color',
  'list-single-line-break': '--medkit-list-single-line-break',
  'list-body-font-size': '--medkit-list-body-font-size',
  'list-indent': '--medkit-list-indent',
  'list-body-line-height': '--medkit-list-body-line-height',
  'list-item-margin-bottom': '--medkit-list-margin-bottom',
}
